import { API_URLS } from '_constants';

export const visitFormUrls = {
  1: API_URLS.assessmentCSV,
  2: API_URLS.enforcementCSV,
  3: API_URLS.educationCSV,
};
